module.exports = "mutation createImage($image: CreateImageInput!) {\n  createImage(input: $image) {\n    image {\n      id\n      url\n    }\n  }\n}\n"